import { z } from 'zod';
import type { SectionEntry, SectionCategoryEntry } from '@/types/section.types';

export const sectionEntrySchema = z.object({
  section_name: z.string().max(150, 'Το όνομα της ενότητας δεν μπορεί να υπερβαίνει τους 150 χαρακτήρες'),
}) satisfies z.ZodType<SectionEntry>;

export const sectionCategoryEntrySchema = z.object({
  category_id: z.string().uuid('Μη έγκυρο ID κατηγορίας'),
}) satisfies z.ZodType<SectionCategoryEntry>;
